/**
 * Shared Pricing Constants and stripe price IDs
 * Maintained in accordance with PRD §12.
 * 
 * If Stripe price IDs change in your Stripe dashboard, update them here.
 * This file serves as the single source of truth for both the frontend
 * and backend to ensure valid Price IDs are used during checkout.
 */
export const PRICES = {
  // Pro Monthly subscription plan ($4/month)
  proMonthly: "price_1Tikke2d2r6FLGvQcDXdGm4T",

  // Pro Annual subscription plan ($29/year)
  proAnnual: "price_1Tikkf2d2r6FLGvQUoDWzBCU",

  // Team Annual subscription plan ($49/seat/year)
  teamAnnual: "price_1Tikkf2d2r6FLGvQ0ByXhzPK",
} as const;

/**
 * Validates whether a given Stripe price ID is permitted for checkout.
 * This function prevents clients from executing subscriptions against unauthorized/zero prices.
 * 
 * @param priceId The price ID string to validate.
 * @returns true if the price ID is approved, false otherwise.
 */
export function isValidPriceId(priceId: string): boolean {
  return Object.values(PRICES).includes(priceId as typeof PRICES[keyof typeof PRICES]);
}
